// Import React hooks
import { useContext, useEffect, useRef, useState } from "react";

// Import the Etsy connection API function
import { completeEtsyConnection } from "api/APIStrichCalls";

// Import the Portal authentication context
import { AuthContext } from "global/context/AuthContext";

const EtsyConnectionCallback = () => {

    // Get the authenticated session
    const { token } = useContext(AuthContext);

    // Track whether the callback has been processed
    const hasCompleted = useRef(false);
    const [message, setMessage] = useState("Connecting your Etsy shop...");

    // Complete the Etsy connection when the page loads
    useEffect(() => {

        // Process the authorisation only once
        if (hasCompleted.current) { return; }
        hasCompleted.current = true;

        // Read the Etsy authorisation response
        const params = new URLSearchParams(window.location.search);
        const state = params.get("state");
        const code = params.get("code");
        const error = params.get("error");

        // Remove the authorisation parameters from the browser address
        window.history.replaceState({}, "", window.location.pathname);

        // Handle declined authorisation
        if (error) {
            setMessage("Etsy authorisation was declined. You can close this tab.");
            return;
        }

        // Check that Etsy returned the required details
        if (!state || !code) {
            setMessage("Missing Etsy authorisation details. You can close this tab.");
            return;
        }

        // Complete the Etsy connection through the authenticated API
        const completeConnection = async () => {

            // Submit the authorisation code and state
            const response = await completeEtsyConnection(token, state, code);

            // Display any failure from the API
            if (!response?.success) {
                setMessage("Etsy connection failed: " + (response?.error_message || response?.error || "Unknown error"));
                return;
            }

            // Confirm the connected Etsy shop
            setMessage("Etsy shop connected: " + response.results.shop_name + ". You can close this tab.");

        };

        completeConnection();

    }, [token]);

    return (

        <div style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
            textAlign: "center"
        }}>

            <div style={{
                maxWidth: "500px",
                width: "100%",
                padding: "40px",
                borderRadius: "16px",
                background: "#ffffff",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
            }}>

                <h2>Connect Etsy</h2>

                <br />

                <p>{message}</p>

            </div>

        </div>

    );

};

export default EtsyConnectionCallback;